export type PipeOperator<T> = (input: T) => T;

const _pipe =
  <T>(a: PipeOperator<T>, b: PipeOperator<T>) =>
  (arg: T) =>
    b(a(arg));
const pipe = <T>(...ops: PipeOperator<T>[]) => ops.reduce(_pipe);

export default pipe;
